/* Ratgeber-Inhaltsverzeichnis: hebt den gerade sichtbaren Abschnitt hervor
   und klappt das TOC auf Mobil nach einem Klick wieder zu.
   Reines Progressive Enhancement – ohne JS bleiben die Ankerlinks nutzbar. */
(function () {
  var toc = document.querySelector('[data-ratgeber-toc]');
  if (!toc) return;

  var links = Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]'));
  if (!links.length) return;

  var targets = links
    .map(function (link) {
      var id = decodeURIComponent(link.getAttribute('href').slice(1));
      var el = id ? document.getElementById(id) : null;
      return el ? { link: link, el: el } : null;
    })
    .filter(Boolean);

  if (!targets.length) return;

  function setActive(entryEl) {
    targets.forEach(function (t) {
      t.link.classList.toggle('is-active', t.el === entryEl);
    });
  }

  if ('IntersectionObserver' in window) {
    var visible = new Map();
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visible.set(entry.target, entry.intersectionRatio);
          } else {
            visible.delete(entry.target);
          }
        });

        // Der oberste sichtbare Abschnitt gewinnt.
        var top = null;
        targets.forEach(function (t) {
          if (visible.has(t.el) && top === null) top = t.el;
        });
        if (top) setActive(top);
      },
      { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
    );

    targets.forEach(function (t) {
      observer.observe(t.el);
    });
  }

  // Auf Mobil nach Klick wieder einklappen (<details>)
  if (toc.tagName === 'DETAILS') {
    toc.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href^="#"]');
      if (link && window.matchMedia('(max-width: 1067px)').matches) {
        toc.open = false;
      }
    });
  }
})();
